module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/_library.js
// module id = 78
// module chunks = 0